import { inject, Injectable } from "@angular/core";

import { WIDGET_HUB } from "@main/reporting.v3/core/widget-hub/constants/widget-hub.constants";
import { WidgetHub, WidgetReference } from "@main/reporting.v3/core/widget-hub/models";

import {
    HtmlContext,
    HtmlSequence,
    HtmlDirective,
    HtmlDirectiveEvaluator,
    HtmlDirectiveEvaluatorSettings,
} from "@main/reporting.v3/widget.html/models";
import { WidgetInputAlias } from "@main/reporting.v3/widget/models/widget-input-alias.enum";
import {
    HtmlBaseExpressionsArgumentService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-argument.service";


@Injectable()
export class HtmlWidgetDirectiveService implements HtmlDirectiveEvaluator {

    private argumentService: HtmlBaseExpressionsArgumentService = inject(HtmlBaseExpressionsArgumentService);

    private widgetHub: WidgetHub = inject(WIDGET_HUB);

    public readonly directive: string = "widget";

    public async evaluate(directive: HtmlDirective, settings: HtmlDirectiveEvaluatorSettings): Promise<any> {
        if (!directive || directive.name !== this.directive || !settings) return null;

        const arg: HtmlSequence = directive.arguments[0];
        const param: any = await this.argumentService.evaluate(arg, settings);
        const code: string = this.argumentService.toString(param);

        // Ensure widget code is passed and it is valid.
        if (!code?.length) return null;

        return this.widget(settings.context, code);
    }

    public async widget(context: HtmlContext, code: string): Promise<any> {
        try {
            if (!context || !code?.length) return null;

            // Request a new widget component from the widget hub.
            const widget: WidgetReference = await this.widgetHub.requestWidgetByCode(code);

            if (!widget) return null;

            // Set necessary inputs for it to match the context of parent widget-html.
            widget.setInput(WidgetInputAlias.Output, context.widgetOutput);
            widget.setInput(WidgetInputAlias.StaticVariables, context.staticVariables);

            return widget.location.nativeElement;

        } catch (error) {
            return null;
        }
    }
}